import React, {useState, useRef, Suspense, useMemo, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import styles from "./EditVideo.module.css";
import {
    Modal,
    TextField,
    Button,
    FormControl,
    MenuItem,
    Select,
    Chip
} from "@material-ui/core";
import {AppState} from "../../root/RootReducer";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import SelectTag from "../../admin/viewer/SelectTag";
import {
    DeleteVideo,
    EditVideo,
    loadVideoStarted
} from "../../common/video/VideoActions";
// import { DeleteVideo, EditVideo } from "../../../common/video/VideoActions";
import UploadDocument from "../../pages/vod/Common/UploadDocument";
import {countCharLength} from "../../utils/ValidationUtils";
import PuiMessage from "../widgets/PuiMessage";
import {LANGUAGE_OPTIONS} from "../../utils/Contants";
import {useSuspenseQueries} from "@tanstack/react-query";
import {isPresenter, UserList,isAdmin} from "src/user/User";
import {Video} from "src/common/video/models/Video";
import {CircularProgress} from "@mui/material";
import {css} from "@emotion/css";

interface EditVideoPageProps {
  // 編集したいビデオのid
  videoId: number;
  // モーダルを閉じる
  CloseEditVideoTab: () => void;
  isSaved: boolean;
  setIsSaved: (isSaved: boolean) => void;
}

function EditVideoPage({
    videoId,
    CloseEditVideoTab,
    isSaved,
    setIsSaved
}: EditVideoPageProps) {
    const history = useNavigate();

    // ユーザー取得
    const {user,  isSuccessEditVideo} = useSelector((state: AppState) => ({
        user: state.user.userInfo,
        isSuccessEditVideo: state.video.isSuccessEditVideo
    }));

    const isOnlyPresenter = useMemo(() => !isAdmin(user?.roles) && isPresenter(user?.roles), [user?.roles]);

    const [{data:videoInfo},{data:professionals}] = useSuspenseQueries({
        queries:[{
            queryKey:["/api/getVideoById",{params: {videoId, userId: user.id}}],
            select:(data) => data as Video
        },{
            queryKey:["/api/getUserInfoList"],
            select: (data) => data as UserList[]
        }]
    });
    const dispatch = useDispatch();
    const inputVideoRef = useRef<HTMLInputElement>(null);
    const inputImageRef = useRef<HTMLInputElement>(null);

    // 入力チェック
    const [isInputAllForm, CheckInputForm] = useState(false);



    // ビデオ編集モーダル非表示
    const CloseEditVideoModal = () => {
        if (isSaved) {
            CloseEditVideoTab();
            // リセット処理
            InputVideoFile(null);
            if (inputVideoRef.current) {
                inputVideoRef.current.value = "";
            }
            ChangeTextVideoFile("");
            ChangePreviewImageFlag(1);
            InputImageUrl("");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
            ChangeTextImageFile("Imageファイルを選択してください");
            ChangeTitleValiFlag(false);
            InputVideoName("");
            ChangeDescriptionValiFlag(false);
            InputVideoDetail("");
            ChangeAlreadyUploadDocumentList([]);
            ChangeDocumentList([]);
            ChangeDocumentNameList([]);
            InputProId("");
            InputVideoLanguage("zh");
            setTagList([]);
            ShowTagSelectModal(false);
            ShowVerifyDeleteModal(false);
            CheckInputForm(false);
        }
    };

    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };

    // ビデオファイル
    const [isEditSuccess, setIsEditSuccess] = useState(false);
    const [inputVideoFile, InputVideoFile] = useState(null);
    const [textVideoFile, ChangeTextVideoFile] = useState(
        videoInfo.fileName
    );
    const [isLimitInputFileSize, ChangeLimitInputFileSize] = useState(false);
    const UserUploadVideo = (event: any) => {
        if (event.target.files.length === 0) {
            ChangeTextVideoFile("Videoファイルを選択してください（4GBまで）");
            InputVideoFile(null);
            if (inputVideoRef.current) {
                inputVideoRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 4294967296) {
                    ChangeLimitInputFileSize(true);
                } else {
                    ChangeTextVideoFile(event.target.files[0].name);
                    InputVideoFile(event.target.files[0]);
                    setIsSaved(false);
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputVideoRef.current) {
                    inputVideoRef.current.value = "";
                }
            }
        } else {
            ChangeTextVideoFile("ファイルを正しく選択してください（4GBまで）");
            InputVideoFile(null);
            if (inputVideoRef.current) {
                inputVideoRef.current.value = "";
            }
        }
    };

    // ファイルサイズ制限バー消去
    const CloseLimitInputFileBar = () => {
        ChangeLimitInputFileSize(false);
    };

    // サムネイル画像ファイル
    // 表示状態 1= defaultUrl 2= imageText 3= imageThumbnail
    const [visiblePreviewImage, ChangePreviewImageFlag] = useState(1);
    const [inputImageUrl, InputImageUrl] = useState(videoInfo.imageUrl);
    const [inputImageFile, InputImageFile] = useState(null);
    const [textImageFile, ChangeTextImageFile] =
    useState("Imageファイルを選択してください");
    const [isLimitInputImageSize, ChangeLimitInputImageSize] = useState(false);
    const ClickPreviewImage = (event: any) => {
        ChangeTextImageFile("Imageファイルを選択してください");
        ChangePreviewImageFlag(2);
        InputImageUrl("");
        setIsSaved(false);
    };
    const UserUploadImage = (event: any) => {
        if (event.target.files.length === 0) {
            ChangeTextImageFile("アップロードするファイルを選択");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 10485760) {
                    ChangeLimitInputImageSize(true);
                } else {
                    ChangeTextImageFile(event.target.files[0].name);
                    InputImageFile(event.target.files[0]);
                    ChangePreviewImageFlag(3);
                    setIsSaved(false);
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputImageRef.current) {
                    inputImageRef.current.value = "";
                }
            }
        } else {
            ChangeTextImageFile("ファイルを正しく選択してください");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        }
    };

    // サムネイルサイズ制限バー消去
    const CloseLimitInputImageBar = () => {
        ChangeLimitInputImageSize(false);
    };

    // ビデオタイトル
    const [isErrorTitleVali, ChangeTitleValiFlag] = useState(false);
    const [inputVideoName, InputVideoName] = useState(videoInfo.title);
    const ChangeTitle = (event: any) => {
        if (countCharLength(event.target.value) > 40) {
            InputVideoName(event.target.value);
            ChangeTitleValiFlag(true);
        } else {
            ChangeTitleValiFlag(false);
            InputVideoName(event.target.value);
        }
        setIsSaved(false);
    };

    // ビデオ要約
    const [isErrorDescriptionVali, ChangeDescriptionValiFlag] = useState(false);
    const [inputVideoDetail, InputVideoDetail] = useState(
        videoInfo.description
    );
    const ChangeDescription = (event: any) => {
        if (countCharLength(event.target.value) > 400) {
            InputVideoDetail(event.target.value);
            ChangeDescriptionValiFlag(true);
        } else {
            ChangeDescriptionValiFlag(false);
            InputVideoDetail(event.target.value);
        }
        setIsSaved(false);
    };

    // 資料アップロード
    const [alreadyUploadDocumentList, ChangeAlreadyUploadDocumentList] = useState(
        videoInfo.extraMaterials
    );
    const [documentList, ChangeDocumentList] = useState<File[]>([]);
    const [documentNameList, ChangeDocumentNameList] = useState<string[]>([]);
    const [isErrorDocumentListLength, ErrorDocumentListLength] = useState(false);

    // プロフェッショナル
    const [inputProId, InputProId] = useState(videoInfo.presenterId);

    const UserInputVideoProfessional = (event: any) => {
        InputProId(event.target.value);
        setIsSaved(false);
    };

    // ビデオ言語
    const [inputVideoLanguage, InputVideoLanguage] = useState(videoInfo.language);
    const UserInputVideoLanguage = (event: any) => {
        InputVideoLanguage(event.target.value);
        setIsSaved(false);
    };

    // タグ
    const [tagList, setTagList] = React.useState<string[]>(videoInfo.tags);
    // タグ選択モーダル表示制御
    const [isOpenTagSelectModal, ShowTagSelectModal] = useState(false);
    // タグ選択モーダル表示
    const OpenTagSelectModal = () => {
        ShowTagSelectModal(true);
    };
    // タグ選択モーダル非表示
    const CloseTagSelectModal = () => {
        ShowTagSelectModal(false);
    };
    // ユーザタグ消去
    const handleDelete = (tagName: string) => () => {
        setTagList((tagList) => tagList.filter((v) => v !== tagName));
        setIsSaved(false);
    };

    // ユーザキャンセルボタン押下
    const ClickCancelButton = () => {
        console.log("ClickCancelButton start");
        CloseEditVideoModal();
    };

    // ユーザ削除ボタン押下
    const ClickDeleteButton = () => {
        console.log("ClickDeleteButton start");
        OpenVerifyDeleteModal();
    };

    // ユーザ編集完了ボタン押下
    const ClickConfirmButton = () => {
        if (visiblePreviewImage !== 1) {
            InputImageUrl("");
        }
        if (
            textVideoFile !== "Videoファイルを選択してください（4GBまで）" &&
      textVideoFile !== "ファイルを正しく選択してください（4GBまで）" &&
      inputVideoName !== "" &&
      inputVideoDetail !== "" &&
      isErrorTitleVali !== true &&
      isErrorDescriptionVali !== true &&
      !isErrorDocumentListLength
        ) {
            if (user) {
                dispatch(loadVideoStarted(videoId, user.id));
            }
            const defaultMaterialIdList: number[] = [];
            videoInfo.extraMaterials.map(function (row) {
                defaultMaterialIdList.push(row.id);
                return null;
            });

            const materialIdList: number[] = [];
            alreadyUploadDocumentList.map(function (row) {
                materialIdList.push(row.id);
                return null;
            });
            const sendMaterialIdList: number[] = defaultMaterialIdList.filter(
                (i) => materialIdList.indexOf(i) === -1
            );

            if (user) {

                setIsSaved(true);
                setIsEditSuccess(true);
                dispatch(
                    EditVideo({
                        userId: user.id,
                        file: inputVideoFile,
                        imageFile: inputImageFile,
                        documentFile: documentList,
                        documentName: documentNameList,
                        materialId: sendMaterialIdList,
                        video: {
                            id: videoId,
                            title: inputVideoName,
                            description: inputVideoDetail,
                            imageUrl: inputImageUrl,
                            presenter: inputProId,
                            language: inputVideoLanguage,
                            tags: tagList,
                            isPublic: true,
                            allowedUserIds: [user.id],
                            allowedUserGroupIds: [],
                            presenters: [inputProId]
                        }
                    })
                );

            }
        } else {
            CheckInputForm(true);
        }
    };

    // ビデオ削除確認モーダル表示制御
    const [isOpenVerifyDeleteModal, ShowVerifyDeleteModal] = useState(false);
    // ビデオ削除確認モーダル表示
    const OpenVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(true);
    };
    // ビデオ削除確認モーダル非表示
    const CloseVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(false);
    };

    // ビデオ削除確認ボタン押下
    const ClickConfirmDeleteVideoButton = () => {
        CloseEditVideoModal();
        CloseVerifyDeleteModal();
        dispatch(DeleteVideo(videoId));
        // 一覧画面に戻って強制リフレッシュー
        history("/videos");
    };

    // ビデオ削除キャンセルボタン押下
    const ClickCancelDeleteVideoButton = () => {
        CloseVerifyDeleteModal();
    };
    
    useEffect(() => {
        if (isSuccessEditVideo && isEditSuccess) {
            CloseEditVideoModal();
        }
    }, [isSuccessEditVideo, isEditSuccess]);
    return (
        <div className={styles.root}>
            <ul className={styles.inputForm}>
                <FormControl>
                    <form name="addVideoForm">
                        {/* ビデオファイル */}
                        <li>
                            <div className={styles.formHelperText}>
                Videoファイル<sup style={{color: "red"}}>*</sup>
                            </div>
                            <div className={styles.form}>
                                <label className={styles.uploadButton}>
                                    <input
                                        id="browserVideoUploader"
                                        ref={inputVideoRef}
                                        multiple
                                        type="file"
                                        accept="video/*"
                                        onChange={UserUploadVideo}
                                        className={styles.fileDisplay}
                                    />
                                    {textVideoFile}
                                </label>
                            </div>
                        </li>
                        <li>
                            <div className={styles.formHelperText}>
                Video言語<sup style={{color: "red"}}>*</sup>
                            </div>
                            <div className={styles.form}>
                                <Select
                                    color="secondary"
                                    id="select-video-language"
                                    variant="outlined"
                                    onChange={UserInputVideoLanguage}
                                    value={inputVideoLanguage}
                                >
                                    {LANGUAGE_OPTIONS !== undefined &&
                    LANGUAGE_OPTIONS.map(
                        (row) => (
                            <MenuItem key={row.value} value={row.value}>
                                {row.label}
                            </MenuItem>
                        )
                    )}


                                </Select>
                            </div>
                        </li>

                        {/* 画像サムネイルファイル */}
                        <li>
                            <div className={styles.formHelperText}>サムネイル</div>
                            {visiblePreviewImage === 1 && (
                                <div style={{display: "flex"}}>
                                    <div className={styles.previewImage}>
                                        <img
                                            alt="defaultThumbnail"
                                            style={{cursor: "pointer"}}
                                            src={inputImageUrl}
                                            onClick={ClickPreviewImage}
                                        />
                                    </div>
                                    <p className={styles.previewText}>
                    サムネイル画像を指定しない場合は、Videoから自動的にサムネイルが抽出されます
                                    </p>
                                </div>
                            )}
                            {visiblePreviewImage === 2 && (
                                <div className={styles.form}>
                                    <label className={styles.uploadButton}>
                                        <input
                                            id="browserPhotoUploader"
                                            ref={inputImageRef}
                                            multiple
                                            type="file"
                                            accept="image/*"
                                            onChange={UserUploadImage}
                                            className={styles.fileDisplay}
                                        />
                                        {textImageFile}
                                    </label>
                                </div>
                            )}
                            {visiblePreviewImage === 3 && (
                                <div style={{display: "flex"}}>
                                    <div className={styles.previewImage}>
                                        {inputImageFile ? (
                                            <img
                                                alt="thumbnail"
                                                style={{cursor: "pointer"}}
                                                src={window.URL.createObjectURL(inputImageFile)}
                                                onClick={ClickPreviewImage}
                                            />
                                        ) : (
                                            <p>No image selected</p>
                                        )}
                                    </div>
                                    <p className={styles.previewText}>
                    サムネイル画像を指定しない場合は、Videoから自動的にサムネイルが抽出されます
                                    </p>
                                </div>
                            )}
                        </li>

                        {/* タイトル */}
                        <li>
                            <div className={styles.formHelperText}>
                タイトル<sup style={{color: "red"}}>*</sup>
                            </div>
                            <div className={styles.form}>
                                <TextField
                                    color="secondary"
                                    style={{width: "100%"}}
                                    id="videoName"
                                    variant="outlined"
                                    placeholder="Videoタイトルを入力"
                                    autoComplete="off"
                                    value={inputVideoName}
                                    onChange={ChangeTitle}
                                    error={isErrorTitleVali}
                                    helperText={
                                        isErrorTitleVali &&
                    "全角20文字（半角40文字）以内で正しく入力してください"
                                    }
                                />
                            </div>
                        </li>

                        {/* プロフェッショナル */}
                        {
                            isOnlyPresenter &&                         <li>
                                <div className={styles.formHelperText}>
                Presenter<sup style={{color: "red"}}>*</sup>
                                </div>
                                <div className={styles.form}>
                                    <Select
                                        color="secondary"
                                        id="demo-simple-select"
                                        variant="outlined"
                                        onChange={UserInputVideoProfessional}
                                        value={inputProId}
                                    >
                                        {professionals !== undefined &&
                    professionals.map(
                        (row) =>
                            row.roles.includes("PRESENTER") && (
                                <MenuItem key={row.id} value={row.id}>
                                    {row.fullName}
                                </MenuItem>
                            )
                    )}
                                    </Select>
                                </div>
                            </li>
                        }


                        {/* 要約 */}
                        <li>
                            <div className={styles.formHelperTextLong}>
                要約<sup style={{color: "red"}}>*</sup>
                            </div>
                            <div className={styles.form}>
                                <TextField
                                    color="secondary"
                                    id="description"
                                    onChange={ChangeDescription}
                                    style={{width: "100%"}}
                                    multiline
                                    rows={5}
                                    autoComplete="off"
                                    value={inputVideoDetail}
                                    variant="outlined"
                                    placeholder="Video要約を入力"
                                    error={isErrorDescriptionVali}
                                    helperText={
                                        isErrorDescriptionVali &&
                    "全角200文字（半角400文字）以内で正しく入力してください"
                                    }
                                />
                            </div>
                        </li>

                        {/* 資料 */}
                        <li>
                            <div className={styles.formHelperTextLong}>資料</div>
                            <UploadDocument
                                alreadyUploadDocumentList={alreadyUploadDocumentList}
                                ChangeAlreadyUploadDocumentList={
                                    ChangeAlreadyUploadDocumentList
                                }
                                ChangeDocumentList={ChangeDocumentList}
                                documentList={documentList}
                                ChangeDocumentNameList={ChangeDocumentNameList}
                                documentNameList={documentNameList}
                                ErrorDocumentListLength={ErrorDocumentListLength}
                                setIsSaved={setIsSaved}
                            />
                        </li>

                        {/* タグ（モーダル表示） */}
                        <li style={{marginBottom: "50px"}}>
                            <div className={styles.formHelperTextLong}>タグ</div>
                            <div className={styles.formTag}>
                                <AddCircleOutlineOutlinedIcon
                                    style={{cursor: "pointer", color: "var(--red)"}}
                                    fontSize="large"
                                    onClick={OpenTagSelectModal}
                                />
                            </div>
                            <div className={styles.tags}>
                                {tagList &&
                  tagList.map((tag) => (
                      <Chip
                          label={tag}
                          key={tag}
                          color="secondary"
                          style={{backgroundColor: "var(--red)"}}
                          size="medium"
                          className={styles.tag}
                          onDelete={handleDelete(tag)}
                      />
                  ))}
                            </div>
                        </li>
                    </form>
                </FormControl>
                <li>
                    {/* 更新ボタン */}
                    <div className={styles.buttonGroup}>
                        {isInputAllForm && (
                            <div className={styles.checkInput}>
                ※全ての項目を正しく入力してください
                            </div>
                        )}
                        <Button
                            size="small"
                            variant="outlined"
                            type="submit"
                            onClick={ClickCancelButton}
                            style={{
                                marginRight: "5px",
                                color: "var(--red)",
                                borderColor: "var(--red)"
                            }}
                            className={styles.updateButton}
                        >
              キャンセル
                        </Button>
                        <Button
                            size="small"
                            variant="outlined"
                            type="submit"
                            onClick={ClickDeleteButton}
                            style={{
                                marginRight: "5px",
                                color: "var(--red)",
                                borderColor: "var(--red)"
                            }}
                            className={styles.updateButton}
                        >
              Video削除
                        </Button>
                        {isSaved ? (
                            <Button
                                size="small"
                                variant="outlined"
                                disabled
                                color="secondary"
                                className={styles.updateButton}
                            >
                編集完了
                            </Button>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                type="button"
                                onClick={ClickConfirmButton}
                                color="secondary"
                                className={styles.updateButton}
                            >
                編集完了
                            </Button>
                        )}
                    </div>
                </li>
            </ul>

            {/* アップロードファイルサイズチェック */}
            <PuiMessage
                open={isLimitInputFileSize}
                onClose={CloseLimitInputFileBar}
                type="error"
                title="4GB以上のファイルはアップロードできません"
                duration={5000}
            />

            {/* アップロードイメージサムネイルサイズチェック */}
            <PuiMessage
                open={isLimitInputImageSize}
                onClose={CloseLimitInputImageBar}
                type="error"
                title="10MB以上の画像はアップロードできません"
                duration={5000}
            />

            {/* アップロードファイルサイズチェック */}
            <PuiMessage
                open={isErrorInputSize}
                onClose={CloseErrorInputBar}
                type="error"
                title="正しいファイルを選択してください"
                duration={5000}
            />

            {/*------------------------ タグ編集モーダル ------------------------*/}
            <Modal open={isOpenTagSelectModal} onClose={CloseTagSelectModal}>
                <SelectTag
                    in={isOpenTagSelectModal}
                    onClose={CloseTagSelectModal}
                    tagList={tagList}
                    setTagList={setTagList}
                    setIsSaved={setIsSaved}
                />
            </Modal>

            {/*------------------------ 動画削除モーダル ------------------------*/}
            <Modal open={isOpenVerifyDeleteModal} onClose={CloseVerifyDeleteModal}>
                <div className={styles.verifyDeleteModal}>
                    <Button onClick={CloseVerifyDeleteModal}/>
                    <ul className={styles.ul}>
                        <li style={{textAlign: "center"}}>対象のVideoを削除しますか</li>
                        <li style={{display: "flex"}}>
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                className={styles.verifyCancelButton}
                                onClick={ClickCancelDeleteVideoButton}
                            >
                キャンセル
                            </Button>
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                className={styles.verifyDeleteButton}
                                onClick={ClickConfirmDeleteVideoButton}
                            >
                削除
                            </Button>
                        </li>
                    </ul>
                </div>
            </Modal>
        </div>
    );
}
function EditVideoSuspense(props:EditVideoPageProps) {

    return (
        <Suspense fallback={
            <div className={css`
            display: flex;
          align-items: center;
          justify-content: center;
          height: 90vh;
        `}
            >
                <CircularProgress style={{
                    color:"red"
                }}
                />
            </div>
        }
        >
            <EditVideoPage {...props}/>
        </Suspense>
    );

}
export default EditVideoSuspense;
